'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { useStore } from 'zustand';

import { Button } from '@/components/ui/button/button.component';
import { ButtonVariant } from '@/components/ui/button/button.types';
import { Link } from '@/components/ui/link/link.component';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { useFeatureFlagContext } from '@/store/feature-flag.store';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface FaqLoginButtonProps {
  label?: string;
  variant?: ButtonVariant;
  className?: string;
}

export const FaqLoginButton = ({
  label = 'Meu cadastro online',
  variant = 'secondary',
  className,
}: FaqLoginButtonProps) => {
  const enableAuth = useStore(
    useFeatureFlagContext,
    (state) => state.enableAuth,
  );

  const { buttonSmFit } = styleFaq();
  const buttonClassName = className ?? buttonSmFit({ className: 'px-12' });
  const analyticsEvent = AnalyticsEnum.CLICK_FAQ_MY_ONLINE_SIGN_IN_BUTTON;

  if (!enableAuth) {
    return null;
  }

  return (
    <Button variant={variant} className={buttonClassName} asChild>
      <Link
        prefetch={false}
        data-testid={DataTestIdEnum.FAQ_LOGIN_BUTTON}
        href="/agendamentos/"
        data-analytics-event={analyticsEvent}
      >
        {label}
      </Link>
    </Button>
  );
};
